import { Component, OnInit, inject } from '@angular/core';
import { SessionService } from '@src/app/modules/auth';
import { INFO_NAVIGATION } from '@src/app/modules/navigation';
import { PagesService } from '@src/app/modules/pages';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss'],
})
export class InformationComponent implements OnInit {
  private readonly pagesService = inject(PagesService);
  private readonly session = inject(SessionService);

  readonly navTree = INFO_NAVIGATION;

  readonly pagesNavItems$ = this.pagesService.pagesForNavigation$;

  get associationMenuVisible() {
    return !!this.session.appConfig?.showAssociationSwitchControl;
  }

  ngOnInit(): void {
    this.pagesService.getPagesForNavigation();
  }
}
